import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=d36f918e&"
import script from "./TopMenu.vue?vue&type=script&lang=ts&"
export * from "./TopMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports